// Minimal stand-in for Facebook's flux Dispatcher — this app only ever
// registers callbacks and dispatches {actionType, payload} objects, so the
// full library (unmaintained, pinned to React 15/16 peers) isn't needed.
class Dispatcher {
  constructor() {
    this.callbacks = [];
  }

  register(callback) {
    this.callbacks.push(callback);
  }

  dispatch(payload) {
    this.callbacks.forEach((callback) => callback(payload));
  }
}

export default new Dispatcher();
